import { render, staticRenderFns } from "./CreateBattleDialog.vue?vue&type=template&id=6bed7702&"
import script from "./CreateBattleDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateBattleDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBattleDialog.vue?vue&type=style&index=0&id=6bed7702&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports